import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    defaultAriaLabel: 'Check Circle Icon',
};

export const CheckCircleIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props} viewBox="0 0 64 64">
            <g
                fill="none"
                stroke="#00b31b"
                stroke-linecap="square"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-width="2"
            >
                <polyline points="18 34 26 42 46 22" />
                <circle cx="32" cy="32" r="29" />
            </g>
        </SvgIcon>
    );
};

